module.exports = __webpack_public_path__ + "static/media/cara_wow.5704c1a7.png";